import type { IconSvgObject } from './types';

const Exchange01Icon: IconSvgObject = [
  ["path", { d: "M10.6939 3.0513C20.8432 2.13597 23.8223 13.711 18.1713 18.5238M17 16V19.5H20.5M13.2951 20.9599C3.19461 21.763 0.166669 10.3002 5.81774 5.48738M7 7.5V4.5H3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Exchange01Icon;
